import React from "react";
import { proposalSlideImageUrl } from "./proposalSlideImageUrl";
import { getSequenceForTemplateKey } from "./proposalTemplateConfig";
import ProposalExtraDynamicPage from "./ProposalExtraDynamicPage";
import { ProposalHeadTermsSlide } from "./ProposalTermsSection";

/**
 * @param {string} templateKey — `gec` | `kbt` | `sw`
 * @param {string} imageBaseUrl — API `proposalTemplateImageBaseUrl` (PROPOSAL_TEMPLATE_IMAGE_BASE_URL)
 */
const ProposalPreviewBody = ({
  templateKey,
  imageBaseUrl,
  createdProposal,
  rowvalue,
  totalHour,
  selectedRange,
  wrapInRow = true,
}) => {
  const sequence = getSequenceForTemplateKey(templateKey);
  if (!sequence?.length) return null;

  const inner = (
    <>
      {sequence.map((step, idx) => {
        if (step.type === "static") {
          const src = proposalSlideImageUrl(
            imageBaseUrl,
            templateKey,
            step.file
          );
          if (!src) {
            return (
              <div
                key={`${templateKey}-${step.file}-missing-${idx}`}
                style={{
                  padding: "24px",
                  background: "#fff3cd",
                  color: "#856404",
                  marginBottom: "8px",
                }}
              >
                Proposal image base URL is not configured on the server (
                PROPOSAL_TEMPLATE_IMAGE_BASE_URL).
              </div>
            );
          }
          return (
            <img
              key={`${templateKey}-${step.file}-${idx}`}
              src={src}
              alt=""
              style={{ width: "100%", height: "auto", display: "block" }}
            />
          );
        }
        if (step.type === "dynamic") {
          if (step.id === "headTerms") {
            return (
              <div
                key={`dyn-head-terms-${idx}`}
                className="col-12 g-0"
                style={{ padding: 0, width: "100%" }}
              >
                <ProposalHeadTermsSlide
                  templateKey={templateKey}
                  createdProposal={createdProposal}
                  rowvalue={rowvalue}
                  totalHour={totalHour}
                  selectedRange={selectedRange}
                />
              </div>
            );
          }
          if (step.id === "extra") {
            return (
              <ProposalExtraDynamicPage
                key={`dyn-extra-${idx}`}
                createdProposal={createdProposal}
                rowvalue={rowvalue}
              />
            );
          }
          return null;
        }
        return null;
      })}
    </>
  );

  if (!wrapInRow) return inner;
  return <div className="row border-left g-0">{inner}</div>;
};

export default ProposalPreviewBody;
